export default __webpack_public_path__ + "static/4-97471a283f288b915d944ae594ed2641.woff";